import React from "react";
import { Search, TrendingUp, TrendingDown, Plug } from "lucide-react";

const CATEGORY_TOPICS = [
  "Bass boats", "Bay boats", "Technical skiffs", "Center consoles", "Pontoon boats",
  "Wake and ski boats", "Offshore fishing boats", "Boat manufacturers", "Boat models",
];

const TrendColumn = ({ up }) => (
  <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-5" data-testid={up ? "search-trending-up" : "search-trending-down"}>
    <div className="flex items-center gap-2 mb-4">
      <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${up ? "bg-emerald-500/15" : "bg-rose-500/15"}`}>
        {up ? <TrendingUp className="w-4 h-4 text-emerald-400" /> : <TrendingDown className="w-4 h-4 text-rose-400" />}
      </div>
      <h3 className="text-sm font-bold text-white">{up ? "Boat Searches Trending Up" : "Boat Searches Trending Down"}</h3>
    </div>
    {/* Data-ready rows, intentionally empty until Google search intelligence is connected. */}
    <div className="space-y-2.5">
      {[0, 1, 2].map((i) => (
        <div key={i} className="flex items-center justify-between rounded-xl border border-dashed border-white/10 px-3 py-2.5">
          <div className="flex items-center gap-2 min-w-0">
            <span className={`w-1.5 h-6 rounded-full ${up ? "bg-emerald-400/40" : "bg-rose-400/40"}`} />
            <div className="h-2.5 w-28 rounded bg-white/10" />
          </div>
          <div className="h-2.5 w-10 rounded bg-white/10" />
        </div>
      ))}
    </div>
    <p className="text-[11px] text-slate-500 mt-3">Keyword, category, market, trend direction, percent change and comparison period will appear here once connected.</p>
  </div>
);

export default function MarineSearchDemand() {
  return (
    <section data-testid="marine-search-demand">
      <div className="rounded-3xl overflow-hidden border border-white/10 bg-navy">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 px-6 pt-6">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-teal-500/15 flex items-center justify-center"><Search className="w-5 h-5 text-teal-300" /></div>
            <div>
              <h2 className="font-serif text-xl font-bold text-white">Marine Search Demand Intelligence</h2>
              <p className="text-sm text-slate-400">Local and regional boating search interest, seasonally adjusted. For RecJet Mind to weigh over time.</p>
            </div>
          </div>
          <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-amber-300 bg-amber-500/10 border border-amber-400/30 rounded-full px-3 py-1.5 self-start" data-testid="search-not-connected-pill">
            <Plug className="w-3.5 h-3.5" /> Google Search Intelligence Not Connected
          </span>
        </div>

        {/* disabled future filters */}
        <div className="flex flex-wrap gap-2 px-6 pt-4">
          {["Geography", "Manufacturer", "Category", "Period"].map((f) => (
            <span key={f} className="text-xs text-slate-500 border border-white/10 rounded-lg px-3 py-1.5 opacity-60 cursor-not-allowed" data-testid={`search-filter-${f.toLowerCase()}`}>{f}</span>
          ))}
        </div>

        <div className="grid md:grid-cols-2 gap-4 p-6">
          <TrendColumn up />
          <TrendColumn up={false} />
        </div>

        <div className="px-6 pb-6">
          <div className="flex flex-wrap gap-1.5">
            {CATEGORY_TOPICS.map((t) => (
              <span key={t} className="text-[11px] text-slate-400 bg-white/5 border border-white/10 rounded-full px-2.5 py-1">{t}</span>
            ))}
          </div>
          <p className="text-[11px] text-slate-500 mt-3">Future sources: Google Trends, Google Ads Keyword Planner historical data, and dealer-authorized Google Search Console. Seasonality is compared against prior years so normal seasonal shifts are not read as unusual demand.</p>
        </div>
      </div>
    </section>
  );
}
